import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Header from '../../component/atom/Header';
import InputPopup from '../../component/atom/Input/InputPopup';
import InputRadio from '../../component/atom/Input/InputRadio';
import Label from '../../component/atom/Label';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import LangPopup from '../../popup/Lang';
import ServedItemPopup from '../../popup/ServedItem';
import { S } from './style';
import { APP } from '../../config/app';
import { CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP, FORM_FIELD_ERROR_FEEDBACK_TEXT, } from '../../config/error';
import { POPUP_TYPE } from '../../config/popup';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/careRequirement'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/careRequirement'].title}/>);
const renderRequiredGenderField = ({ requiredGender, requiredGenderOptionList, isRequiredGenderError, careOrderBabyFormInputFieldRefMap, handleRequiredGenderInputChange, }) => (<InputRadio elementRef={careOrderBabyFormInputFieldRefMap.requiredGender} title='是否指定照服員性別' isFull optionList={requiredGenderOptionList} radioGroupName='requiredGender' refValue={requiredGender || ''} onInputChange={handleRequiredGenderInputChange} isError={isRequiredGenderError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderLangField = ({ parsedLang, isLangError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick, }) => (<InputPopup elementRef={careOrderBabyFormInputFieldRefMap.lang} onInputClick={() => handleInputPopupClick({
        errorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.lang,
        popup: POPUP_TYPE.LANG,
    })} title='主要溝通語言' displayValue={parsedLang} placeHolder='請選擇' isError={isLangError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderServedItemField = ({ parsedServedItem, isServedItemError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick, }) => (<InputPopup elementRef={careOrderBabyFormInputFieldRefMap.servedItem} onInputClick={() => handleInputPopupClick({
        errorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.servedItem,
        popup: POPUP_TYPE.SERVED_ITEM,
    })} title='需求項目' displayValue={parsedServedItem} placeHolder='請選擇' isError={isServedItemError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderFooter = ({ handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutFooter>
    <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
      上一步
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleForwardButtonClick}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
const renderPopup = ({ popupType, setPopupType, }) => (<>
    <LangPopup popupType={popupType} setPopupType={setPopupType}/>
    <ServedItemPopup popupType={popupType} setPopupType={setPopupType}/>
  </>);
export default function View({ 
// data
isLoading, requiredGender, requiredGenderOptionList, isRequiredGenderError, isLangError, isServedItemError, careOrderBabyFormInputFieldRefMap, careOrderBabyFormForCareRequirementPage, popupType, 
// func
setPopupType, handleRequiredGenderInputChange, handleInputPopupClick, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const requiredGenderField = useMemo(() => renderRequiredGenderField({
        requiredGender,
        requiredGenderOptionList,
        isRequiredGenderError,
        careOrderBabyFormInputFieldRefMap,
        handleRequiredGenderInputChange,
    }), [
        requiredGender,
        requiredGenderOptionList,
        isRequiredGenderError,
        careOrderBabyFormInputFieldRefMap,
        handleRequiredGenderInputChange,
    ]);
    const langField = useMemo(() => renderLangField({
        parsedLang: careOrderBabyFormForCareRequirementPage.parsedLang,
        isLangError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    }), [
        careOrderBabyFormForCareRequirementPage.parsedLang,
        isLangError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    ]);
    const servedItemField = useMemo(() => renderServedItemField({
        parsedServedItem: careOrderBabyFormForCareRequirementPage.parsedServedItem,
        isServedItemError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    }), [
        careOrderBabyFormForCareRequirementPage.parsedServedItem,
        isServedItemError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    ]);
    const footer = useMemo(() => renderFooter({ handleBackButtonClick, handleForwardButtonClick }), [handleBackButtonClick, handleForwardButtonClick]);
    const popups = useMemo(() => renderPopup({ popupType, setPopupType }), [popupType, setPopupType]);
    return (<RWDPageLayout isLoading={isLoading}>
      {popups}
      {header}
      <S.Layout>
        <S.LayoutInputFields isLast>
          <Label title='案件需求'/>
          {requiredGenderField}
          {langField}
          {servedItemField}
        </S.LayoutInputFields>
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
